/* eslint-disable no-unused-vars */
import http from '../../Utils/http';

const Signup = {
  name: 'signup',
  state: {
    data: {},
    addUser: {},
    loading: false,
    error: '',
    totalCount: 0,
    message:'',
    tableHeader: ['name', 'type', 'owner'],
    rpp: 10,
  },
  reducers: {
    getSignupRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        data:'',
        message:''
      };
    },
    getReceiveSignupData(state, payload) {
      return {
        ...state,
        addUser:{},
        loading:false,
        message:payload
      };
    },
    getReceived(state, payload) {
      return {
        ...state,
        data: Object.assign({}, state.data, payload),
      };
    },

    getRequestSignupFailed(state, payload) {
      return {
        ...state,
        error: payload,
        message:'',
        loading:false,
      };
    },
    getRequestSignupClear(state, payload) {
      return {
        ...state,
        error: '',
        message:'',
        loading:false,
        addUser:{}
      };
    },
    getErrorClear(state, payload) {
      return {
        ...state,
        error: '',
        message:'',
        loading:false,
      };
    },
  },
  effects: (dispatch) => ({
    addData(data) {
      dispatch.signup.getReceived(data);
    },

    async sendData(data) {
     try {
        this.getSignupRequested();
        const response = await http.post(`auth/withOwner`, data);
        this.getReceiveSignupData(response.data.message);
      } catch (err) {
        this.getRequestSignupFailed(err.response.data.error)
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: 'Invalid Credentials',
            open: true,
          },
        });
      }

    },
    async clearSignupData() {
      this.getRequestSignupClear();
    },
    async clearErrorMessage() {
      this.getErrorClear();
    }
  }),
};

export default Signup;
